/*
 *@Description:车辆黑名单
 *@Author: zhengff
 *@Date: 2019-04-25 13:58:48
 */
const routes = [
  {
    path: '/carPatrolBlack',
    name: 'carPatrolBlack',
    component: () => import('./view/carPatrolBlack.vue'),
    meta: {
      requireAuth: true,
      routerAlive: true
    },
  },
]

export default routes
